import { mockApiClient } from "./apiClient";
import type { PacketDocument, PacketDocumentType } from "../schemas/packetSchemas";
import type { PacketStatus } from "../types/domain";

const requiredDocumentTypes: PacketDocumentType[] = ["seller_license", "dscsa_transaction_history", "lot_expiry_attestation", "shipping_sop"];

export function calculatePacketReadiness(documents: Array<Pick<PacketDocument, "type" | "status">>): { status: PacketStatus; missing: PacketDocumentType[] } {
  const accepted = new Set(documents.filter(document => document.status === "accepted").map(document => document.type));
  const missing = requiredDocumentTypes.filter(type => !accepted.has(type));
  return { status: missing.length === 0 ? "ready" : "blocked", missing };
}

export const packetService = {
  listPackets: () => mockApiClient.listPackets(),
  getPacket: (id: string) => mockApiClient.getPacket(id) ?? mockApiClient.listPackets()[0],
  calculatePacketReadiness,
};
